import { Components, PageComponent } from "@/logic/main/types";
import { JackpotTile, JackpotsContext } from "@/types/jackpotTypes";

const supportedPageComponents = ['JackpotWidget', 'JackpotDrawer'];

export const isSupportedPageComponent = (component: { type: string, id: string }) => {
  return supportedPageComponents.includes(component.type);
}

export const getJackpotsContextFromPage = (components: Components): JackpotsContext => {
    const jackpotsContext: JackpotsContext = {};

    for (const component of Object.values(components)) {
        if (isSupportedPageComponent(component) && isComponentWithJackpotTile(component)) {
            const { provider, code } = component.properties.jackpot_tile;
            const jackpotProvider = jackpotsContext[provider] || {};
            const jackpotCodeState = jackpotProvider[code] || { components: [] };

            jackpotCodeState.components.push(component.properties.id);
            jackpotsContext[provider] = {
                ...jackpotProvider,
                [code]: jackpotCodeState,
            };
        }
    }

    return jackpotsContext;
}

export const isComponentWithJackpotTile = (
  component: PageComponent
): component is PageComponent<{ jackpot_tile: JackpotTile, id: string }> => {
  return (
    typeof component === 'object' &&
    component !== null &&
    'properties' in component &&
    typeof component.properties === 'object' &&
    component.properties !== null &&
    'jackpot_tile' in component.properties &&
    typeof component.properties.jackpot_tile === 'object' &&
    component.properties.jackpot_tile !== null &&
    'provider' in component.properties.jackpot_tile &&
    typeof component.properties.jackpot_tile.provider === 'string' &&
    'code' in component.properties.jackpot_tile &&
    typeof component.properties.jackpot_tile.code === 'string' &&
    'id' in component.properties &&
    typeof component.properties.id === 'string'
  );
};